
import Components from "../imports/components"
const Test = () => {
 
  return (
    <div>
     <Components.ChartPie/>
    </div>
  );
};

export default Test;
